import { type Component, For } from 'solid-js';

export const STREAK_PATH_MILESTONES = [3, 7, 14, 30] as const;

export function nextStreakPathMilestone(completedDays: number): number | null {
  return STREAK_PATH_MILESTONES.find((milestone) => completedDays < milestone) ?? null;
}

export const ChildStreakPathCard: Component<{ completedDays: number; onOpen?: () => void }> = (
  props,
) => {
  const nextMilestone = () => nextStreakPathMilestone(props.completedDays);
  return (
    <section class="child-streak-path" data-testid="child-streak-path">
      <div>
        <div class="child-dashboard-kicker">YOUR ROUTINE STREAK</div>
        <h2>
          {props.completedDays} day{props.completedDays === 1 ? '' : 's'} earned
        </h2>
        <p>
          {props.completedDays === 0
            ? 'Complete a routine and get it approved to earn your first day.'
            : nextMilestone() === null
              ? 'You reached every streak star! Approved routine days still add to your total.'
              : `Your next star is at ${nextMilestone()} days. Missing a day does not erase the days you already earned.`}
        </p>
      </div>
      <div
        class="child-streak-path-steps child-streak-path-milestones"
        aria-label="Routine streak path milestones"
      >
        <For each={[...STREAK_PATH_MILESTONES]}>
          {(milestone) => (
            <span
              class="child-streak-path-step"
              classList={{
                'is-complete': props.completedDays >= milestone,
                'is-next': nextMilestone() === milestone,
              }}
              aria-label={`${milestone} routine days${props.completedDays >= milestone ? ' complete' : ''}`}
            >
              <span aria-hidden="true">{props.completedDays >= milestone ? '★' : '•'}</span>
              <small>{milestone}</small>
            </span>
          )}
        </For>
      </div>
      <button
        type="button"
        class="ghost child-streak-path-open"
        onClick={() => props.onOpen?.()}
        data-testid="child-streak-path-open"
      >
        Show which days counted
      </button>
    </section>
  );
};
